(function(global){

  document.addEventListener('DOMContentLoaded', () => {
    initProductSecondImage();
    initCollapsibleList({
      mode: 'fade', // fade || height --> height expands and shrinks, fade fades in and out
      listContainer: 'hs-collapsible-list-container',
      toggleButton: 'hs-collapsible-list-btn',
      isOpen: 'hs-collapsible-list-is-open',
      list: 'hs-collapsible-list',
      listItem: 'hs-collapsible-list-item',
      collapsibleItem: 'hs-collapsible-list-item-is-collapsible',
      itemDetails: 'hs-collapsible-list-item-details'
    });
    initScrollToLinks();
  });


  function initProductSecondImage() {
    if (!document.body.classList.contains('product-template')) return;

    var tries = 0, maxTries = 60; // poll up to ~3s at 50ms
    var timer = setInterval(function () {
      tries++;
      var mg = document.querySelector('media-gallery');
      var swiper = mg && mg.sliderInstance && mg.sliderInstance.slider;
      if (swiper && swiper.slides && swiper.slides.length > 1) {
        clearInterval(timer);
        swiper.slideTo(1, 0);
      } else if (tries >= maxTries) {
        clearInterval(timer);
      }
    }, 50);
  }

  function initScrollToLinks() {
    document.addEventListener("click", function (e) {
      const link = e.target.closest('.hs-scroll-link');
      if (!link) return;

      e.preventDefault();

      const href = link.getAttribute("href");
      if (!href || !href.startsWith("#")) return;

      const targetId      = href.slice(1);
      const target        = document.getElementById(targetId);
      const header        = document.querySelector('.header'); // adjust if needed
      const headerHeight  = header ? header.offsetHeight : 0;
      const scrollElement = document.scrollingElement;
        

      const targetPosition =
        target.getBoundingClientRect().top +
        scrollElement.scrollTop -
        headerHeight;

      scrollElement.scrollTo({
        top: targetPosition,
        behavior: "smooth"
      });
    });
  }

  

  function dotClass(className) {
    return '.' + className;
  }

  function initCollapsibleList(classNames) {
    if (!classNames) return;

    var containers = document.querySelectorAll(dotClass(classNames.listContainer));
    if (!containers.length) return;

    document.addEventListener('click', function () {
      closeAllDetails();
    });

    function openList(container, list) {
      // Put items back into flow
      setCollapsibleItemsDisplay(container, true);

      // If fade mode: add class and show immediately
      if (classNames.mode === 'fade') {
        container.classList.add('is-fade-mode');
        container.classList.add(classNames.isOpen);
        list.style.height = '';
        return;
      }

      // Height mode (your current animation)
      container.classList.remove('is-fade-mode');
      container.classList.add(classNames.isOpen);

      list.style.height = '0px';
      var target = list.scrollHeight;

      animateHeight(list, 0, target, function () {
        list.style.height = '';
      });
    }

    function closeList(container, list) {
      // If fade mode: remove open class, then remove from flow shortly after
      if (classNames.mode === 'fade') {
        container.classList.add('is-fade-mode');
        container.classList.remove(classNames.isOpen);
        list.style.height = '';

        // allow opacity transition to run, then remove from flow
        setTimeout(function () {
          setCollapsibleItemsDisplay(container, false);
        }, 140);

        //scrollToElement(container, -130);
        return;
      }

      // Height mode (your current animation)
      container.classList.remove('is-fade-mode');

      var from = list.scrollHeight;
      container.classList.remove(classNames.isOpen);

      list.style.height = from + 'px';
      animateHeight(list, from, 0, function () {
        list.style.height = '';
        setCollapsibleItemsDisplay(container, false);
      });

      // scrollToElement(container, -130);
    }


    function closeAllDetails(except) {
      var openDetails = document.querySelectorAll(
        dotClass(classNames.itemDetails) + '.is-visible'
      );

      for (var i = 0; i < openDetails.length; i++) {
        if (except && openDetails[i] === except) continue;
        openDetails[i].classList.remove('is-visible');
      }
    }

    function setCollapsibleItemsDisplay(container, show) {
      var items = container.querySelectorAll(dotClass(classNames.collapsibleItem));
      for (var i = 0; i < items.length; i++) {
        items[i].style.display = show ? 'flex' : 'none'; // adjust if your tiles aren't flex
      }
    }

    function animateHeight(el, from, to, done) {
      el.style.height = from + 'px';
      el.offsetHeight; // force reflow
      el.style.height = to + 'px';

      var onEnd = function (e) {
        if (e.propertyName !== 'height') return;
        el.removeEventListener('transitionend', onEnd);
        if (done) done();
      };
      el.addEventListener('transitionend', onEnd);
    }

    for (var i = 0; i < containers.length; i++) {
      (function (container) {
        var buttons = container.querySelectorAll(dotClass(classNames.toggleButton));
        if (!buttons.length) return;

        var list = container.querySelector(dotClass(classNames.list));
        if (!list) return;

        (function(list){ 
          list.addEventListener('click', function (e) {
            // Find the clicked tile
            var item = e.target.closest(dotClass(classNames.listItem));
            if (!item || !list.contains(item)) return;

            // Find details inside that tile
            var details = item.querySelector(dotClass(classNames.itemDetails));
            if (!details) return;

            var isOpen = details.classList.contains('is-visible');

            // Close all others first
            closeAllDetails(details);

            // Toggle current one
            if (!isOpen) {
              details.classList.add('is-visible');
            } else {
              details.classList.remove('is-visible');
            }

            // Prevent document click from immediately closing it
            e.stopPropagation();
          });
        })(list);

        // Initial state: if closed, remove collapsible items from flow
        if (!container.classList.contains(classNames.isOpen)) {
          setCollapsibleItemsDisplay(container, false);
        }

        for (var j = 0; j < buttons.length; j++) {
          (function (btn) {
            btn.addEventListener('click', function (e) {
              e.preventDefault();
              e.stopPropagation(); // recommended so it doesn't interfere with details clicks

              var isOpen = container.classList.contains(classNames.isOpen);

              if (isOpen) {
                closeList(container, list);
              } else {
                openList(container, list);
              }
            });
          })(buttons[j]);
        }

      })(containers[i]);
    }
  }


})(window);